<template>
  <div>
    <h1 class="text-center">Om Hillsbrook</h1>

    <div class="text-center mt-4">
      <p>Kennel Hillsbrook er en lille kennel i Haslev på Sydsjælland.</p>

      <p>Jeg, Claus er aktiv jæger, siden jeg som 16 årig tog jagttegn 1984, og har haft labrador retrievere siden 1994, og jeg bruger mine hunde aktivt i Dansk Retriever Klud uden for jagtsæsonen.</p>

      <p>Jeg opdrætter mine hvalpe med jagtegenskaber og sundhed som de primære avismål, men foretrækker en køn kraftfuld type labrador retriever, men helt uden på nogen måde at virke grov, tung og klodset, for at kunne klare at stå for strabadserne på en hel jagtdag.</p>

      <p>Der er hvalpe når tiden er til det så se evt, under min hvalpeside med informationer om kuld.</p>
    </div>

    <!-- Todo: Mindre height? -->
    <v-img :src="`${publicPath}images/ung114.jpg`"></v-img>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Om',
  data: () => ({
    publicPath: process.env.BASE_URL
  }),
  computed: {
    ...mapState(['test', 'dogs'])
  }
};
</script>
